import React from "react";
import { Quote, Star } from "lucide-react";

const TESTIMONIALS = [
  {
    id: 1,
    quote:
      "Melanie built our clinic's chatbot in under a week. We've captured 40+ leads in the first month — most while we were sleeping. Money well spent.",
    name: "D. Patel, DDS",
    role: "Sample dental client",
    stars: 5,
  },
  {
    id: 2,
    quote:
      "She rewrote my entire dissertation introduction. My committee called it 'the strongest opening they'd read all semester.' I literally cried.",
    name: "Aisha M.",
    role: "Sample PhD candidate",
    stars: 5,
  },
  {
    id: 3,
    quote:
      "I came for a chatbot. I left with a smarter business. Melanie thinks like an owner, writes like a professor, and builds like a developer.",
    name: "Marcus J.",
    role: "Sample e-commerce founder",
    stars: 5,
  },
];

export default function Testimonials() {
  return (
    <section data-testid="testimonials-section" className="bg-cream-warm section-pad">
      <div className="container-edit">
        <div className="text-center mb-14 max-w-2xl mx-auto">
          <div className="eyebrow mb-5">Kind Words</div>
          <h2 className="h-section text-plum-deepest mb-4">
            What clients <span className="font-display-italic text-gold-deep">say</span>.
          </h2>
          <p className="text-sm text-muted-plum italic">
            Note: Melavate Studios just launched. The testimonials below are illustrative
            samples shown until verified Fiverr reviews are live.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {TESTIMONIALS.map((t) => (
            <article
              key={t.id}
              data-testid={`testimonial-${t.id}`}
              className="bg-cream rounded-2xl p-7 border border-plum/8 relative"
            >
              <Quote className="absolute top-5 right-5 text-gold/30" size={32} />
              <div className="flex gap-1 mb-5">
                {Array.from({ length: t.stars }).map((_, i) => (
                  <Star key={i} size={16} className="fill-gold text-gold" />
                ))}
              </div>
              <p className="font-display-italic text-lg text-plum-deepest leading-relaxed mb-7">
                "{t.quote}"
              </p>
              <div className="pt-5 border-t border-plum/10">
                <div className="font-semibold text-plum-deepest">{t.name}</div>
                <div className="text-xs uppercase tracking-wider text-muted-plum mt-1">
                  {t.role}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
